import styled from "styled-components";



export const SettingsInfo = styled.div<{isMobile: boolean}>`
    //overflow: visible;
    width: 100%;
    //min-width: 390px;
    height: 100%;
    //min-height: 700px;
    box-sizing: border-box;
    //max-width: 473px;

    font-size: 13px;
    color: #595D69;
    //padding: 10px 0;
    display: flex;
    flex-direction: column;
    //justify-content: space-between;
    align-items: center;
    //z-index: 5;
    //background: #27292E;
    //border-radius: 0 0 11px 11px;
    //border-radius: 11px;
    //border: 1px solid #27292E;
    //top: 86px;
    cursor: default;
    min-height: 400px;
    overflow-y: scroll;
    
    //todo
    // @media (max-height: 940px) {
    //     //justify-content: space-evenly;
    //      min-height: ${({isMobile}) => isMobile ? '600px' : '450px'};
    // }
    // @media (max-height: 700px) and (min-width: 370px) and (max-width: 380px) {
    //     min-height: 450px;   
    // }
    //@media (max-height: 850px) {
    //    justify-content: space-evenly;
        //width: 390px;
        //height: 100%;
        //min-height: 100%;
        //min-height: ${({isMobile}) => isMobile ? '600px' : '500px'};
        //overflow-y: visible;
    //}
    
    //@media (max-height: 850px) {
    //    //width: 390px;
    //    //height: 100%;
    //    //min-height: 100%;
    //    
    //    overflow-y: visible;
    //}
    //height: calc(100vh - 163px);
    //@media (max-height: 940px) {
    //    height: calc(100vh - 110px);
    //    //overflow: visible;
    //    //max-height: 660px;
    //    //height: 518px;
    //}
    //@media (max-height: 650px) {
    //    height: calc(100vh - 110px);
    //    //overflow: visible;
    //    //max-height: 660px;
    //    //height: 480px;
    //}
`
export const SettingCellHeader = styled.div`
    //width: 331px;
    width: 100%;
    font-size: 10px;
    color: #23AF91;
    letter-spacing: 2px;
    user-select: none;
    //@media (max-height: 940px) {
    //    width: 240px;
    //    font-size: 13px;
    //}
`
export const InnerSettingCell = styled.div`
    width: 100%;
    //height: 58px;
    //height: 40px;
    height: 50px;
    //height: 89px;
    border-radius: 14px;
    //border: 1px solid #5B71BF;
    border: 1px solid #ffffff10;
    background: #ffffff05;
    //border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //padding: 0 20px;
    box-sizing: border-box;

    @media (max-height: 940px) {
        //height: 40px;
        //width: 240px;
    }
    //@media (max-height: 650px) {
    //    height: 46px;
    //    width: 280px;
    //}
`

export const SettingInput = styled.input`
    //font-size: 22px;
    //color: #595D69;
    width: 210px;
    font-size: 16px;
    padding-left: 15px;
    overflow: hidden;
    height: 20px;
    //border: none;
    //border-left: 1px solid #5B71BF;
    //border-left: 1px solid #595D69;
    //border: 1px solid white;
    border-left: none;
    border-bottom: none;
    border-top: none;
    border-right: none;
    color: #fff;
    outline: none;
    background: transparent;

    /* якщо хочеш без виділення при фокусі */

    &:focus {
        outline: none;
    }
    &::placeholder {
        color: #595D69;
        //font-size: 22px
    }
    @media (max-height: 940px) {
        //height: 20px;
     
        //width: 190px;
        
        //&::placeholder {
        //    font-size: 16px;
        //    font-style: italic;
        //}
    }
`
export const ApplySettingField = styled.div`
    width: 100%;
    height: 30px;
    //background: #323537;
    border: 1px solid #ffffff10;
    background: #ffffff05;
    color: #929AA5;
    font-size: 12px;
    border-radius: 14px;
    align-content: center;
    text-align: center;
    cursor: pointer;
     &:hover {
         color: white;
     }
    transition: transform 0.15s ease;
    &:active {
        transform: scale(0.95);
        color: #23AF91;
    }
    //@media (max-height: 940px) {
    //    width: 240px;
    //    height: 40px;
    //}
`

export const SettingSelectListContainer = styled.div`
    display: flex;
    flex-direction: column;
    top: 55px;
    //border: 1px solid white;
    left: -1px;
    width: 100%;
    height: 155px;
    background: #ffffff05;
    position: absolute;
    z-index: 5;
    box-sizing: border-box;
    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 0;
        visibility: hidden;
    }

    border: 1px solid #ffffff05;
    border-radius: 14px;

    //@media (max-height: 940px) {
    //    top: 39px;
    //    width: 240px;
    //    max-width: 240px;
    //    height: 151px
    //}
    //@media (max-height: 650px) {
    //    top: 43px;
    //    width: 280px;
    //    max-width: 280px;
    //    height: 151px
    //}
    
`
export const SettingSelectListItem = styled.div<{ isIncluded: boolean }>`
    height: 51px;
    min-height: 51px;
    //min-height: 40px;
    font-size: 12px;
    letter-spacing: 1.2px;
    //align-content: center;
    color: ${({isIncluded}) =>  isIncluded ? '#FF5E66' : 'inherit' };
    box-sizing: border-box;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    &:hover {
        background: #ffffff05;
    }
    
    & > div:nth-child(2) { 
        display: ${({isIncluded}) => isIncluded ? 'flex' : 'none'};
        //font-size: 30px;
        align-items: center;
        justify-content: center;
        padding-bottom: 5px;
        & > svg {
            fill: #FF5E66;
        }
    }

    //@media (max-height: 940px) {
    //    //padding: 0 14px;
    //    //min-height: 30px;
    //    //height: 30px;
    //    font-size: 17px;
    //}
`

export const SettingCell = styled.div<{isTop?: boolean}>`
    //margin-top: 40px;
    margin-top: ${({isTop}) => isTop ? 0 : 20}px;
    width: 100%;
    //height: 80px;
    height: 66px;
    display: flex;
    align-items: center;
    flex-direction: column;
    //color: #5B71BF;
    font-size: 16px;
    justify-content: space-between;
    box-sizing: border-box;
    @media (max-height: 940px) {
        //margin-top: 30px;
        //height: 80px;
        width: 100%;
        font-size: 14px;
    }

    //@media(max-height: 650px) {
    //    //margin-top: 30px;
    //    height: 70px;
    //    width: 260px;
    //    font-size: 13px;
    //}
`

export const SelectSettingCell = styled(SettingCell)`
    //@media (max-height: 940px) {
    //    height: 66px;
    //}
`
export const ApplySettingCell = styled(SettingCell)`
    flex-direction: row;
    justify-content: center;
    //@media (max-height: 940px) {
    //    height: 66px;
    //}
`
export const SettingSelect = styled.div<{ isActive: boolean }>`
    width: 100%;
    //height: 58px;
    height: 50px;
    border: 1px solid #ffffff10;
    //border-top-left-radius: 4px;
    //border-top-right-radius: 4px;
    border-radius: 14px;
    background: #ffffff05;
    color: #929AA5;
    padding: 0 15px;
    font-size: 12px;
    align-content: center;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-height: 940px) {
        //height: 40px;
        //font-size: 13px;
        //width: 240px;
    }
    //@media (max-height: 650px) {
    //    height: 44px;
    //    font-size: 13px;
    //    width: 280px;
    //}

    & > svg {
        stroke: #929AA5;
    }
`
export const SettingIncremental = styled.div<{isTop?: boolean}>`
    width: 100%;
    height: 50%;
    border-left: 1px solid #ffffff10;
    border-bottom: ${({isTop}) => isTop ? '1px solid #ffffff10' : 'none'};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    & > svg {
        stroke: #929AA5;
    }
    &:hover {
        & > svg {
            stroke: white;
        }
    }
    transition: transform 0.15s ease;
    &:active {
        transform: scale(0.95);
        & > svg {
            stroke: #23AF91;
        }
    }
`
export const IncrementalContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 48px;
    height: 100%;
`